import React from "react";
import { makeStyles } from "@mui/styles";
import { Typography } from "../components/Typography";
import { HeaderMenu } from "../components/Header";
import { ItemCarousel } from "../components/ItemsCarousel";
import { MobileWeb } from "../components/mobile/BreakPoint";
import { Theme } from "@mui/material";
import { Footer } from "../components/Footer";
import { MobileFooter } from "../components/mobile/MobileFooter";
import { ItemCarousel2 } from "../components/ItemsCarousel2";
import halfCircleBlue from "../asset/half_circle_blue.png";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    margin: "0px auto",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      maxWidth: 824,
      width: "100%",
      margin: "0px",
      height: "100%",
      minWidth: "auto",
    },
  },
  body: {
    width: "100%",
    alignSelf: "center",
    display: "flex",
    flexDirection: "column",
    alignContent: "center",
    justifyContent: "center",
    alignItems: "center",
    borderTop: "1px solid #0000003b",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      maxWidth: 824,
      width: "90%",
      height: "100%",
      margin: "12px auto",
      borderTop: "none",
    },
  },
  topTitleCon: {
    display: "flex",
    flexDirection: "column",
    marginTop: 30,
    marginBottom: 20,
    right: 505,
    position: "relative",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      right: 83,
    },
  },
  topTitleCon2: {
    display: "flex",
    flexDirection: "column",
    marginTop: 30,
    marginBottom: 20,
    right: 300,
    position: "relative",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      right: 0,
    },
  },
  top_text1: {
    position: "relative",
    display: "flex",
    justifyContent: "center",
    color: "#204FA1",
    // marginTop: "90px",
    // marginBottom: "103px",
    maxWidth: 1290,
    fontSize: "18px",
    fontWeight: 600,
    textAlign: "center",
    [theme.breakpoints.down(MobileWeb.mobile)]: {},
  },
  top_text2: {
    position: "relative",
    display: "flex",
    justifyContent: "center",
    color: "#204FA1",
    maxWidth: 1290,
    fontSize: "18px",
    fontWeight: 600,
    textAlign: "center",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      fontSize: 18,
      marginBottom: 20,
      right: 0,
    },
  },
  carouselBox: {
    display: "flex",
    alignSelf: "center",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    position: "relative",
    background: "#fdf5fd",
    height: 620,
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      display: "block",
      minHeight: 430,
      height: "100%",
    },
  },
  box: {
    display: "flex",
    placeContent: "center",
  },
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  poster: {
    width: "438px",
    height: "605px",
  },
  halfCircleBlue: {
    position: "relative",
    width: 65,
    bottom: 5,
    right: 30,
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      right: 32,
      bottom: 5,
    },
  },
  halfCircleBlue2: {
    position: "relative",
    width: 65,
    bottom: 5,
    right: 30,
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      right: 0,
    },
  },
}));

export const ResearchPage = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <HeaderMenu />
      <div className={classes.body}>
        <div className={classes.topTitleCon}>
          <img
            src={halfCircleBlue}
            alt="blueHalfCircle"
            className={classes.halfCircleBlue}
          />
          <Typography variant="H3" className={classes.top_text1}>
            수상 & 연구
          </Typography>
        </div>
        <div className={classes.carouselBox}>
          <ItemCarousel />
        </div>
        <div className={classes.topTitleCon2}>
          <img
            src={halfCircleBlue}
            alt="blueHalfCircle"
            className={classes.halfCircleBlue2}
          />
          <Typography variant="H3" className={classes.top_text2}>
            Global Patient Safety Eucation Program with Nursing School
          </Typography>
        </div>
        <div className={classes.carouselBox}>
          <ItemCarousel2 />
        </div>
      </div>
      <Footer />
      <div style={{ display: "flex" }}>
        <MobileFooter />
      </div>
    </div>
  );
};
